import { useMutation } from "@tanstack/react-query";
import {
  type InitiateCampaignTransactionResponse,
  postTransactionsCampaignTransactionsInitiate,
  type ErrorResponse,
  type InitiateCampaignTransactionRequest,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Translations/Resources";
import { toast } from "sonner";

type Props = {
  onSuccess?: (response: InitiateCampaignTransactionResponse) => void;
  onError?: (
    error: ErrorResponse,
    variables: InitiateCampaignTransactionRequest,
  ) => void;
};

export const useCampaignTransactionInitiateMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const { t } = useResource();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      postTransactionsCampaignTransactionsInitiate,
    ),
    onSuccess: (data: InitiateCampaignTransactionResponse) => {
      toast.success(t(Resources.Hooks.CampaignTransaction.Success));
      onSuccess?.(data);
    },
    onError: (
      error: ErrorResponse,
      variables: InitiateCampaignTransactionRequest,
    ) => {
      toast.error(t(Resources.Hooks.CampaignTransaction.Error));
      onError?.(error, variables);
    },
  });
};
